export default __webpack_public_path__ + "static/media/icon.ff22094c.svg";